// This import loads the firebase namespace along with all its type information.
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

// eslint-disable-next-line no-undef
export const firebaseConfig = FIREBASE_CONFIG;

